import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Grid, Stack, Tooltip, Typography } from '@mui/material';
import {
  deleteDireccionesAction,
  allDireccionesAction,
  setActivoDireccionesAction,
} from '../DireccionesAction';
import * as CONST from '../../../constants/FieldsConst';
import { textLabels } from '../../../helpers';
import { PARAMS_DIRECCIONES } from '../DireccionesReducer';
import { LoadingWidget } from '../../../widgets';
import { Chip } from '@mui/material';
import ActionsListWidget from '../../../widgets/ActionsList';
import { useNotification } from '../../../helpers/Notification';
import DeleteModalComponent from '../../../widgets/modals/DeleteModal';

const ListadoDirecciones = ({ setOpenModalForm, params }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const direccionesStore = Redux.useSelector((state) => state.direcciones);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {};
      dispatch({ type: PARAMS_DIRECCIONES, payload });
      if (direccionesStore.all && direccionesStore.all.length === 0) {
        await allDireccionesAction(dispatch, {
          ...direccionesStore.params,
          ...payload,
          ...params,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (direccionesStore.all && direccionesStore.all.length > 0) {
      const rowsData = [];
      direccionesStore.all.forEach((el) =>
        rowsData.push({
          ...el,
          ciudad: el.ciudad?.ciudad,
          estado: el.ciudad?.estado?.estado,
          pais: el.ciudad?.estado?.pais?.pais,
          actions: el,
        }),
      );
      setRows(rowsData);
    }
  }, [direccionesStore.all]);

  const _handleEditClick = async (value) => {
    await setActivoDireccionesAction(dispatch, value);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteDireccionesAction(
      { dispatch, notify },
      direccionesStore.activo.id,
      {
        ...direccionesStore.params,
        ...params,
      },
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.direccion.name,
      label: CONST.direccion.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.ciudad.name,
      label: CONST.ciudad.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estado.name,
      label: CONST.estado.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.pais.name,
      label: CONST.pais.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.isPrincipal.name,
      label: CONST.isPrincipal.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title={value ? 'Número principal' : 'No principal'}
              placement="top"
            >
              <Chip
                label={value ? 'Principal' : 'No'}
                size="small"
                color={value ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(value)}
                onDelete={async () => {
                  await setActivoDireccionesAction(dispatch, value);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={direccionesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {direccionesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {direccionesStore.activo.direccion}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoDirecciones;
